import { InfoAlert } from 'src/components/atoms/alerts/InfoAlert';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { useCPULabel } from 'src/features/MM/hooks/useCPULabel';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { useRoiDef } from 'src/utils/calculateRoi';
import {
  incrementalMetricDef,
  mediaEffectDef,
  MEDIA_INVESTMENT_DEF,
  romiDef,
  getCPUDef,
} from 'src/utils/metricDefinitions';

const getBodyText = (
  romiEnabled: boolean,
  cpuLabel: string,
  roiDef: string,
  metricLabel: string,
) => {
  let bodyText = `${MEDIA_INVESTMENT_DEF}

  ${incrementalMetricDef(metricLabel)}

  ${getCPUDef(cpuLabel, metricLabel)}

  ${mediaEffectDef(metricLabel)}

  ${roiDef}`;

  if (romiEnabled) {
    bodyText = bodyText + `\n\n${romiDef(metricLabel)}`;
  }

  return bodyText;
};

type SummaryInfoAlertProps = {
  infoOpen: boolean;
  onClose: () => void;
};

export const SummaryInfoAlert: React.FC<SummaryInfoAlertProps> = ({
  infoOpen,
  onClose,
}) => {
  const cpuLabel = useCPULabel();
  const roiDef = useRoiDef();
  const { romiEnabled } = useMMDataContext();
  const { metricLabel } = useKpiMetricLabels();

  const bodyText = getBodyText(romiEnabled, cpuLabel, roiDef, metricLabel);

  return (
    <InfoAlert
      headerText={'Summary'}
      bodyText={bodyText}
      isOpen={infoOpen}
      onClose={onClose}
    />
  );
};
